import { useAppSelector } from "@/core/app/hooks"
import { useScannerFilesLoader } from "@/core/app/slices/integrations/useScannerFilesLoader"
import { SCANNER_INTEGRATION_IDS } from "@/core/app/slices/integrations/scannerConstants"
import type { RootState } from "@/core/app/store"

interface EasyRxScansImportOptions {
  onUpperStl: (file: File | null) => void
  onLowerStl: (file: File | null) => void
}

export function useEasyRxScansImport({ onUpperStl, onLowerStl }: EasyRxScansImportOptions) {
  const selectedScannerPatient = useAppSelector(
    (state: RootState) => state.integrationsService.selectedScannerPatient,
  )
  const easyRxPrescriptionId = useAppSelector(
    (state: RootState) => state.caseService.caseDetail?.extra_info?.easyrx?.prescription_id,
  )
  const { startLoading } = useScannerFilesLoader()

  const importEasyRxScans = (overrideExternalCaseId?: string | number) => {
    const externalCaseId = overrideExternalCaseId ?? selectedScannerPatient?.external_case_id ?? easyRxPrescriptionId
    if (!externalCaseId) return
    startLoading({
      externalCaseId,
      scannerName: SCANNER_INTEGRATION_IDS.EASYRX,
      requiredKeys: ["upper", "lower"],
      onUpperReady: onUpperStl,
      onLowerReady: onLowerStl,
    })
  }

  return { importEasyRxScans }
}
